/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Civil_Engineering27Inputs */

const en__field_enum_csjensblank_civil_engineering27 = /** @type {(inputs: _Field_Enum_Csjensblank_Civil_Engineering27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Civil & Environmental Engineering`)
};

const de__field_enum_csjensblank_civil_engineering27 = /** @type {(inputs: _Field_Enum_Csjensblank_Civil_Engineering27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bau- & Umweltingenierwissenschaften`)
};

/**
* | output |
* | --- |
* | "Civil & Environmental Engineering" |
*
* @param {_Field_Enum_Csjensblank_Civil_Engineering27Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_civil_engineering27 = /** @type {((inputs?: _Field_Enum_Csjensblank_Civil_Engineering27Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Civil_Engineering27Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_civil_engineering27(inputs)
	return de__field_enum_csjensblank_civil_engineering27(inputs)
});
export { _field_enum_csjensblank_civil_engineering27 as "_field_enum_CSJENSBLANK_CIVIL_ENGINEERING" }